var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C23.2845 0 30 6.7155 30 15C30 23.2845 23.2845 30 15 30C6.7155 30 0 23.2845 0 15C0 6.7155 6.7155 0 15 0ZM14.985 12H13.5C13.1177 12.0004 12.75 12.1468 12.4719 12.4093C12.1939 12.6717 12.0266 13.0304 12.0042 13.4121C11.9818 13.7938 12.106 14.1696 12.3514 14.4627C12.5968 14.7559 12.9449 14.9443 13.3245 14.9895L13.5 15V22.485C13.5 23.265 14.091 23.91 14.85 23.991L15.015 24H15.75C16.0655 24 16.3729 23.9006 16.6286 23.7158C16.8843 23.531 17.0752 23.2703 17.1742 22.9708C17.2732 22.6713 17.2753 22.3481 17.1801 22.0474C17.0849 21.7466 16.8973 21.4835 16.644 21.2955L16.5 21.201V13.515C16.5 12.735 15.909 12.09 15.15 12.009L14.985 12ZM15 7.5C14.6022 7.5 14.2206 7.65804 13.9393 7.93934C13.658 8.22064 13.5 8.60218 13.5 9C13.5 9.39782 13.658 9.77936 13.9393 10.0607C14.2206 10.342 14.6022 10.5 15 10.5C15.3978 10.5 15.7794 10.342 16.0607 10.0607C16.342 9.77936 16.5 9.39782 16.5 9C16.5 8.60218 16.342 8.22064 16.0607 7.93934C15.7794 7.65804 15.3978 7.5 15 7.5Z",
    fill: "#905F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.f042f4ac76ce5b00e85145e28556db5e.svg";
export { ForwardRef as ReactComponent };